// External library imports
import { useState, useEffect } from 'react'
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router'


// Font imports
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

// Local component imports
import { BlueprintsPage, WorkflowRunsPage, MarketplacePage } from './components/blueprints'
import { UserProvider, User } from './context/UserContext'
import ErrorPage from './error-page'
import Dashboard from './routes/dashboard'
import Flow from './routes/flow.$projectid'
import Logout from './routes/logout'


// Store imports
import { useWhoAmi } from './stores/userStore'

// Type imports

// Router configuration
const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/flow/:projectId',
    element: <Flow />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/blueprints',
    element: <BlueprintsPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/workflows',
    element: <WorkflowRunsPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/marketplace',
    element: <MarketplacePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/logout',
    element: <Logout />,
    errorElement: <ErrorPage />,
  },
])

function App() {
  // Hook to fetch user data
  const result = useWhoAmi()
  const { data, loading, success, error, errorData, execute } = result

  // User state
  const [user, setUser] = useState<User>({
    id: '',
    name: '',
    email: '',
    isAdmin: false,
  })

  // Fetch user data on component mount
  useEffect(() => {
    execute()
  }, [execute])

  // Update user state when data is successfully fetched
  useEffect(() => {
    if (success && data) {
      setUser({
        id: data.userId,
        name: data.userName,
        email: data.userEmail,
        isAdmin: data.userIsAdmin,
      })
    }
  }, [success, data])

  // Log user state changes (disabled for now)
  // useEffect(() => {}, [user])

  // Display loading state
  if (loading) {
    return <div>Loading...</div>
  }

  // Display error state
  if (error) {
    return <div>Error occurred: {errorData?.message}</div>
  }

  // Render router when data is loaded
  return (
    <UserProvider value={user}>
        <RouterProvider router={router} />
      
    </UserProvider>
  )
}

export default App
